import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['classicSearch', 'aiSearch'];

  connect() {
    this.#exposeToApplication();

    if (this.#aiSearchParamEnabled()) {
      this.enable();
    }
  }

  disconnect() {
    this.#removeFromApplication();
  }

  enable() {
    // Drop `.search` while AI is active so WorkPageNav's $('.search') toggles
    // cannot re-show the classic panel alongside AI search.
    this.classicSearchTarget.classList.add('hidden');
    this.classicSearchTarget.classList.remove('search');
    this.aiSearchTarget.classList.remove('hidden');
  }

  disable() {
    this.aiSearchTarget.classList.add('hidden');
    this.classicSearchTarget.classList.add('search');
    this.classicSearchTarget.classList.remove('hidden');
  }

  #aiSearchParamEnabled() {
    const params = new URLSearchParams(window.location.search);
    return params.get('ai-search') === 'true';
  }

  #exposeToApplication() {
    window.Application = window.Application || {};
    window.Application.enableAiWorkSearch = () => this.enable();
    window.Application.disableAiWorkSearch = () => this.disable();
  }

  #removeFromApplication() {
    if (!window.Application) {
      return;
    }

    delete window.Application.enableAiWorkSearch;
    delete window.Application.disableAiWorkSearch;
  }
}
